var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.enabledTabCount),expression:"enabledTabCount"}],staticClass:"tabs",class:_vm.classObject},[_c('div',{staticClass:"tab-wrap"},[_c('ul',{staticClass:"tab-list",class:_vm.listCustomClass},_vm._l((_vm.tabList),function(tab,index){return _c('li',{key:tab.title,staticClass:"tab-item",class:{
            active: index === _vm.active,
            disabled: tab.disabled,
            hidden: tab.hidden,
            selected: tab.selected
          },domProps:{"innerHTML":_vm._s(tab.title)},on:{"click":function($event){return _vm.setTab(index)}}})}),0)]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }